/**
 * Builds a two-letter initials string from the first letters of first and last name.
 * @util
 * @__NO_SIDE_EFFECTS__
 */
export function getInitials(firstName, lastName) {
    return `${firstName?.[0] ?? ''}${lastName?.[0] ?? ''}`;
}
//# sourceMappingURL=getInitials.js.map